const loadAll = function (filter, vm) {
    if (filter.result) {
        return new Promise(function(resolve){
            resolve(filter.result);
        });
    }
    return vm.$loading({
        url: filter.url,
        params: {
            number: 1,
            size: 100
        }
    }).then(function (res) {
        if (res.success) {
            if (res.data && res.data.length) {
                filter.result = res.data;
            }
            return res.data;
        } else {
            vm.$weui.topTips(res.message, 2000);
        }
    });
};

/**
 * 下拉框筛选
 */
export default {
    displayField: 'display',
    valueField: 'value',
    handler(filter, vm) {
        loadAll(filter, vm).then(function (data) {
            var options = data.map(o => {
                return Object.assign(o, {
                    label: o[filter.displayField],
                    value: o[filter.valueField]
                });
            });
            vm.$weui.picker(options, {
                defaultValue: [filter.value],
                onConfirm: function (result) {
                    if (result.length) {
                        filter.value = result[0].value;
                        vm.onChange(filter);
                    }
                }
            });
        });
    },
    renderer(filter) {
        return filter.value || filter.label;
    },
    fn(value, filter) {
        return {
            type: "enum",
            field: filter.name,
            operation: "in",
            value: "'" + value + "'"
        };
    }
}